// IMPORTANT TO NOTE:
// Actions/states associated with "navigation" are only for recording purpose.
// ReactNavigation does not actually support using Redux as its state storage.
// We only use these Redux action/states to keep track of navigation status for
// analytics purpose.

import {handleActions} from 'redux-actions';

import {SIGN_OUT} from '/redux/action/auth.action';
import {NAVIGATE} from '/redux/action/navigation.action';
import {withPayload} from '/util/reducer.util';

import authSignOut from './navigation/auth/signOut';
import navigate from './navigation/navigate';

const initialState = {
  currentPath: null,
  currentScreen: null,
  currentScreenParams: null,
};

export default handleActions(
  {
    [NAVIGATE]: withPayload(navigate),
    [SIGN_OUT]: withPayload(authSignOut),
  },
  initialState,
);
